module.exports = __webpack_public_path__ + "img/JULIANA S.c5b95c9a.jpeg";